import { envToBoolean } from './utils';

export const SHOW_SOURCE_IN_OGI_MINI_LEGEND = envToBoolean(process.env.NEXT_PUBLIC_SHOW_SOURCE_IN_OGI_MINI_LEGEND);

export const SHOW_SELECT_DESELECT_IN_OGI_MINI = envToBoolean(process.env.NEXT_PUBLIC_SHOW_SELECT_DESELECT_IN_OGI_MINI);
